import type { TypePolicies } from '../../../../../utils/types/TypePolicies';

const STATIC_ANON_URL = 'https://static-assets.frame.io/app/anon.jpg';
const isAnonImage = (str: string | null | undefined) => str === STATIC_ANON_URL;

export const typePolicies: TypePolicies = {
  Images: {
    fields: {
      original: {
        merge: (_existing, incoming) =>
          isAnonImage(incoming) ? null : incoming,
      },
    },
  },
};
